import {
  REQUEST_GET_USER_PROFILE_START,
  REQUEST_GET_USER_PROFILE_COMPLETE,
  REQUEST_GET_USER_PROFILE_ERROR,
  SUBMIT_COMPLAINT_START,
  SUBMIT_COMPLAINT_COMPLETE,
  SUBMIT_COMPLAINT_ERROR,
  UPDATE_PROFILE_INFO_START,
  UPDATE_PROFILE_INFO_COMPLETE,
  UPDATE_PROFILE_INFO_ERROR,
  CLEAR_PROFILE_ERROR,
  SET_USER_STATUS_UNAUTHORISED,
  SUBMIT_FINCH_ACCESS_TOKEN_START,
  SUBMIT_FINCH_ACCESS_TOKEN_COMPLETE,
  SUBMIT_FINCH_ACCESS_TOKEN_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  userProfileError: undefined,
  userData: undefined,
  isUpdateProfileStarted: false,
  isFetchProfileStarted: false,
  isSubmitComplaintStarted: false,
  isUserUnauthorised: false,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case REQUEST_GET_USER_PROFILE_START:
      return {
        ...state,
        isFetchProfileStarted: true,
        userProfileError: undefined,
      };
    case REQUEST_GET_USER_PROFILE_COMPLETE:
      return {
        ...state,
        userData: payload.data,
        isFetchProfileStarted: false,
        userProfileError: undefined,
      };
    case REQUEST_GET_USER_PROFILE_ERROR:
      return {
        ...state,
        userProfileError: payload.error,
        isFetchProfileStarted: false,
      };
    case SUBMIT_COMPLAINT_START:
      return {
        ...state,
        isSubmitComplaintStarted: true,
        submitComplaintError: undefined,
      };
    case SUBMIT_COMPLAINT_COMPLETE:
      return {
        ...state,
        isSubmitComplaintStarted: false,
        submitComplaintError: undefined,
      };
    case SUBMIT_COMPLAINT_ERROR:
      return {
        ...state,
        submitComplaintError: payload.error,
        isSubmitComplaintStarted: false,
      };
    case UPDATE_PROFILE_INFO_START:
      return {
        ...state,
        isUpdateProfileStarted: true,
        updateProfileError: undefined,
      };
    case UPDATE_PROFILE_INFO_COMPLETE:
      return {
        ...state,
        userData: payload.data,
        isUpdateProfileStarted: false,
        updateProfileError: undefined,
      };
    case UPDATE_PROFILE_INFO_ERROR:
      return {
        ...state,
        updateProfileError: payload.error,
        isUpdateProfileStarted: false,
      };
    case SUBMIT_FINCH_ACCESS_TOKEN_START:
      return {
        ...state,
        isSubmitFinchAccessTokenStarted: true,
        submitFinchAccessTokenError: undefined,
      };
    case SUBMIT_FINCH_ACCESS_TOKEN_COMPLETE:
      return {
        ...state,
        isSubmitFinchAccessTokenStarted: false,
        submitFinchAccessTokenError: undefined,
      };
    case SUBMIT_FINCH_ACCESS_TOKEN_ERROR:
      return {
        ...state,
        submitFinchAccessTokenError: payload.error,
        isSubmitFinchAccessTokenStarted: false,
      };
    case CLEAR_PROFILE_ERROR:
      return {
        ...state,
        userProfileError: undefined,
        submitComplaintError: undefined,
        updateProfileError: undefined,
      };
    case SET_USER_STATUS_UNAUTHORISED:
      return {
        ...state,
        isUserUnauthorised: true,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
